import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import { useAbRedirect } from "@/lib/useAbRedirect";

export default function Landing() {
  useAbRedirect(
    "/child-custody-attorney-orange-county-vsl",
    "/child-custody-attorney-orange-county-vsl-v2",
    "custody"
  );
  return (
    <main data-testid="landing-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero source="Child Custody" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Child Custody" />
      <Footer />
    </main>
  );
}
